import React from 'react';

import { Popper } from '@material-ui/core';
import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';

import { TextField } from '..';

export interface AutocompleteProps {
  className?: string;
  filterOptions?: (options: any) => any[];
  getOptionLabel?: (option: any) => string;
  label?: string;
  onChange?: any;
  onInputChange?: any;
  options?: any[];
  placeholder?: string;
  renderOption?: (option: any) => React.ReactNode;
  startIcon?: JSX.Element;
}

export const Autocomplete = (props: AutocompleteProps): JSX.Element => {
  const {
    className = '',
    filterOptions,
    getOptionLabel,
    label = '',
    onChange,
    onInputChange,
    options = [],
    placeholder = '',
    renderOption,
    startIcon,
  } = props;

  return (
    <MuiAutocomplete
      autoComplete
      className={className}
      filterOptions={filterOptions}
      freeSolo
      getOptionLabel={getOptionLabel}
      onChange={onChange}
      options={options}
      PopperComponent={(props) => (
        <Popper
          {...props}
          modifiers={{
            flip: {
              enabled: false,
            },
          }}
        ></Popper>
      )}
      renderInput={(props) => (
        <TextField
          {...props}
          label={label}
          InputProps={{
            ...props.InputProps,
            startAdornment: startIcon,
          }}
          onChange={onInputChange}
          placeholder={placeholder}
        />
      )}
      renderOption={renderOption}
    />
  );
};
